<app-header [progress]="6" [title]="locale.currentTranslation.overviewHeader" data-testid="contact-validation-header"></app-header>
<div class="base-content-container" data-testid="contact-validation-container">
  <div class="headline3" data-testid="contact-validation-title">{{ locale.currentTranslation.contactValidation1 }}
  </div>
  <div class="headline3">{{ locale.currentTranslation.contactValidation3 }}
  </div>
  @if (personalInformation) {
    <div>
      <app-text-input
        [type]="'tel'"
        [(value)]="personalInformation.phone"
        [placeholder]="locale.currentTranslation.witnessPhonePlaceholder"
        [showError]="showErrorMessage"
        [required]="true"
        data-testid="input-phone"
        [attr.aria-label]="locale.currentTranslation.witnessPhonePlaceholder"
      ></app-text-input>
    </div>
  }
  @if (showErrorMessage) {
    <div class="caption1 error-text" data-testid="phone-validation-error" role="alert">
      {{ locale.currentTranslation.invalidPhoneNumber }}
    </div>
  }
  <div style="margin-top: 20px;" class="headline3" data-testid="verification-code-title">{{ locale.currentTranslation.contactValidation2 }}
  </div>
  <div  style="display: flex; justify-content: space-between; margin-top: 32px; margin-bottom: 32px;" data-testid="verification-code-inputs">
    @for (val of codeInputs; track val || i; let i = $index) {
      <div class="code-input-wrapper">
        <input
          class="code-input headline1"
          type="number"
          maxlength="1"
          [value]="codeInputs[i]"
          (input)="onInput($event, i)"
          (keydown)="onKeyDown($event, i)"
          (paste)="onPaste($event)"
          #codeInputRefs
          [attr.data-testid]="'input-code-' + i"
          [attr.aria-label]="'Verification code digit ' + (i + 1)"
          />
      </div>
    }
  </div>
  <div class="minimalistic-button" style="border: black 1px solid; border-radius: 16px;" (click)="resendCode()" data-testid="btn-resend-code" role="button" tabindex="0">
    {{locale.currentTranslation.resendCode}}
  </div>
</div>
<div class="main-button-spacing">
  <button class="main-button" (click)="nextClicked()" data-testid="btn-confirm" role="button" tabindex="0">{{ locale.currentTranslation.confirm }}</button>
</div>
<app-footer data-testid="contact-validation-footer"></app-footer>
